import ProgressBar from './progress.js';

export default ProgressBar;
